import { Grid2x2XIcon, XIcon } from "lucide-react";
import { useState } from "react";
import { createPortal } from "react-dom";

export default function ChangeColumnVisibility(props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <style>
        {`
          .modal {
            display: flex;
            justify-content: center;
            align-items: center;
            position: fixed;
            z-index: 1;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            overflow: auto;
            background-color: rgba(0, 0, 0, 0.4);
            opacity: 0;
            visibility: hidden; 
            transition: 200ms;
          }

          .modal-content {
            background-color: #fefefe;
            padding: 20px;
            border: 1px solid #cccccc;
            width: 80%;
            max-width: 600px;
            position: relative;
          }

          .close-button {
            margin-right: auto;
          }

          .close-button:hover,
          .close-button:focus {
            color: black;
            text-decoration: none;
            cursor: pointer;
          }

          .form-container {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 30px;
            direction: rtl;
            padding: 20px;
          }

          .form-container > div {
            display: flex;
            align-items: center;
            gap: 8px;
            justify-content: right;
          }

          .option-input {
            width: 15px;
            height: 15px;
          }

          .option-label {
            display: block;
            text-align: right;
            margin: 0;
          }
        `}
      </style>
      <button
        style={{
          outline: "none",
          // marginLeft: "100%",
          marginBottom: "10px",
          marginLeft: "10px",
        }}
        onClick={() => setIsOpen(true)}>
        <Grid2x2XIcon size={25} />
      </button>
      {createPortal(
        <div
          className="modal"
          style={{
            opacity: isOpen ? 1 : 0,
            visibility: isOpen ? "visible" : "hidden",
          }}
          onClick={() => setIsOpen(false)}>
          <div className="modal-content" onClick={event => event.stopPropagation()}>
            <button
              className="close-button"
              style={{
                outline: "none",
              }}
              onClick={() => setIsOpen(false)}>
              <XIcon size={25} />
            </button>
            <div className="form-container">
              {props.selectedTable?.headers.map(header => (
                <div key={header.id}>
                  <input
                    type="checkbox"
                    name="options"
                    className="option-input"
                    checked={header.isVisible}
                    onClick={() => props.onChangeVisibility(header.id)}
                  />
                  <label className="option-label">{header.title}</label>
                </div>
              ))}
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
